(function () {
  const soldoutPopupBtn = document.querySelector(".product-soldout-notification form[data-notification-form] button[type='submit']");
  console.log(soldoutPopupBtn);
  if(!soldoutPopupBtn) return;

  soldoutPopupBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const form = soldoutPopupBtn.closest("form[data-notification-form]");
    if (form.reportValidity()) {
      const currentProduct = parseInt(document.querySelector('input[type="hidden"][name="product-id"]').value);
      const currentVariant = parseInt(document.querySelector('.product__content .form__width input[type="hidden"][name="id"]').value);
      const email = form.querySelector("input[type='email']").value;

      fetch("https://a.klaviyo.com/api/v1/catalog/subscribe", {
        "headers": {
          "accept": "application/json, text/plain, */*",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Access-Control-Allow-Origin": "*"
        },
        "mode": "no-cors",
        "body": new URLSearchParams({
          "a": "SwhLH7",
          "g": "WGFg6J",
          "email": email,
          "platform": "shopify",
          "variant": currentVariant,
          "product": currentProduct,
          "accept_marketing": true
        }),
        "method": "POST"
      }).then(res => {
        const paragraph = document.createElement('P');
        paragraph.classList.add("ts-success");
        paragraph.innerText = "You subscribed successfully"
        form.querySelector("input[type='email']").parentNode.insertBefore(paragraph, form.querySelector("input[type='email']").nextSibling);
      }).catch(err => {
        console.error(err);
      });
    }
  })
})();